import fetchWithAuthorization from './fetch-with-authorization'
import { END_POINTS } from './end-points'

export const syncHighnoteData = async (financialAccountId) => {
  return fetchWithAuthorization({
    path: END_POINTS.SYNC_HIGHNOTE_DATA,
    method: 'POST',
    body: JSON.stringify({ financialAccountId })
  })
}
